export default __webpack_public_path__ + "static/media/020-Holstentor.302962c1.svg";